export default __webpack_public_path__ + "static/media/img-legal-1-s-en.dd814841.png";